import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useChildrenCardIdsOfStoryCard = (cardId: string | undefined) : string[] => {
  const cardDb = useSelector((state: RootState) => state.cardDb);
  const ids = Object.keys(cardDb.cards).filter(id => {
    const card = cardDb.cards[id];
    return card.sheetKind === 'story' && card.parentId === cardId;
  });
  return ids;
}

export default useChildrenCardIdsOfStoryCard;
